import Image from 'next/image';
import getPublicConfig from '@/utils/getPublicConfig';
import { NextSeo } from 'next-seo';

import styled from '@emotion/styled';
import xw from 'xwind';

import { TOOLS_PATH } from '@/common/constants/routes';
import { TOOLS_META_DESC } from '@/common/constants/seo';
import { toolGroups } from '@/common/constants/tools';
import { Container } from '../../../components';
import { CheckListSection } from '../components';

const TitleMain = styled.h1(
  xw`
    text-center tracking-wide mt-14 mb-7
    text-2xl md[mt-20 mb-14 text-3xl] lg:text-4xl
  `,
);

const ToolsPageWrapper = styled.div(xw`bg-light_beige`);

const ToolsPage = (): JSX.Element => {
  const publicRuntimeConfig = getPublicConfig();
  const ogUrl = `${publicRuntimeConfig.LOCATION_ORIGIN}${TOOLS_PATH}`;
  return (
    <>
      <NextSeo
        title="Free Tools & Checklists"
        description={TOOLS_META_DESC}
        openGraph={{
          type: 'tools',
          site_name: 'OneVillage',
          url: ogUrl,
        }}
      />
      <ToolsPageWrapper>
        <div css={xw`relative h-44`}>
          <Image
            src="/images/tools/hero.jpg"
            layout="fill"
            alt="Tools"
            objectFit="cover"
          />
        </div>
        <Container>
          <div>
            <TitleMain>
              Download Our Free Tools
              <br />& Checklists
            </TitleMain>
          </div>
          <div>
            {toolGroups.map((t) => (
              <CheckListSection key={t.id} {...t} />
            ))}
          </div>
        </Container>
      </ToolsPageWrapper>
    </>
  );
};

export default ToolsPage;
